export default __webpack_public_path__ + "static/media/AF.16102b81.ico";